import React from 'react';

import { List, Datagrid, FilterForm } from 'components/list';
import { TextField } from 'components/field';
import { EditButton } from 'components/button';

import { SORT_ASC } from "reducers/resource/list/queryReducer";
import * as urls from './urls';
import * as utils from "./utils";


const CustomTextField = (props) => {
  const _record = { ...(props.record || {}) };

  _record.quota = _record.quota_type !== utils.QUOTA_TYPE_UNLIMITED ? (_record.quota || '-') : '-';
  _record.quota_type = utils.QUOTA_TYPE_NAME[_record.quota_type];
  _record.start = new Date(_record.start).toLocaleDateString();
  _record.end = new Date(_record.end).toLocaleDateString();
  _record.status = _record.is_active ? '✓' : '';

  return (
    <TextField 
      {...props}
      record={_record}
    />
  )
};

export const PromotionList = (props) => {
  return (
    <List
      {...props}
      hasCreate={true}
      filters={<FilterForm />}
      sort={{ field: 'shop_id', order: SORT_ASC}}
      autoLoadData={true}
    >
      <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
        <TextField source="id" label="ID"/>
        <TextField source="name" label="Name"/>
        <CustomTextField source="start" label="Start Date"/>
        <CustomTextField source="end" label="End Date"/>
        <CustomTextField source="quota_type" label="Quota Type"/>
        <CustomTextField source="quota" label="Quota"/>
        <CustomTextField source="status" label="Status"/>
        <EditButton linkTo={urls.promotionEditFrontendPath} label="Edit"/>
      </Datagrid>
    </List>
  );
}



// WEBPACK FOOTER //
// ./src/routes/product/PromotionList.js